@use "src/sedestral/sass/mixins/positioning";
@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/extends/boxs";
@use "src/sedestral/sass/icons/icons";
@use "src/sedestral/sass/extends/animations";

.staticMobileNavigation {
  .navigation {
    position: fixed;
    bottom: 0;
    left: 0;
    background: var(--black);
    height: 58px;
    width: 100%;
    z-index: 99;
    box-shadow: 0px -3px 5px rgb(0 0 0 / 4%);
    margin-bottom: env(safe-area-inset-bottom);
    display: flex;

    .cases {
      display: flex;
      width: 100%;
      height: 100%;

      .case {
        height: 100%;
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        @include animations.ripple;

        &.selected {
          .icon {
            filter: var(--icon-white) !important;
          }
        }

        &.home {
          .icon {
            @include icons.ico("black-lineal-h");
          }
        }

        &.target {
          .icon {
            @include icons.ico("black-lineal-target");
          }
        }

        &.audit {
          .icon {
            @include icons.ico("black-audit");
          }
        }

        &.pie {
          .icon {
            @include icons.ico("black-audit-analyse");
          }
        }

        &.tech {
          .icon {
            @include icons.ico("black-lineal-tech");
          }
        }

        &.ai {
          .icon {
            width: 24px !important;
            height: 24px !important;

            @include icons.ico("black-lineal-ai");
          }
        }

        &.blog {
          .icon {
            @include icons.ico("black-lineal-blog");
          }
        }

        .iconContainer {
          width: 100%;

          @include positioning.flex-globally;

          .icon {
            height: 19px;
            width: 19px;
            filter: var(--black-sur-icon);
          }
        }

        .notification {
          background: var(--red);
          position: absolute;
          font-size: 9px;
          height: 15px;
          width: 15px;
          border-radius: 100%;
          border: 3px solid var(--white);
          color: var(--white);
          top: 6px;
          right: calc(50% - 21px);


          @include texts.font("semi-bold");
          @include positioning.flex-globally;
        }

        .entity {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .avatar {
            height: 32px;
            width: 32px;
            position: relative;
          }
        }
      }
    }
  }
}